import { axios } from '@/plugins/axios';

export function getMotifs() {
	return axios.get('/aat-api/motifs');
}

export function getMotsIgnores() {
	return axios.get('/aat-api/motifs/ignores');
}

export function getMotifsDuMoment() {
	return axios.get('/aat-api/motifs/moment');
}

export function getListeCategories() {
	return axios.get('/aat-api/motifs/categories');
}

export function getDureeIndicative(codeMotif: string) {
	return axios.post('/aat-api/motifs/fichier', {
		type: 'json',
		libelle: codeMotif,
		chemin: 'motifs/json/indicativesDuree/'
	});
}

export function getTypesTravail() {
	return axios.post('/aat-api/motifs/fichier', {
		type: 'json',
		libelle: 'typesTravail',
		chemin: 'motifs/json/'
	});
}
